<template>
  <el-container>
    <el-header id="header" class="loginHeader" style="height: 120px">
      <div style="float:left">
        <img src="../assets/sfy/logo.png"/>
      </div>
      <div class="title">
        <div class="title-main">广东省妇幼保健院</div>
        <div class="title-sub">广东省妇幼检验协作信息平台</div>
      </div>
    </el-header>
    <el-main v-bind:style="containerStyle" style="overflow: hidden;">
      <div class="mainContainer">
        <el-header class="title2">
          <div>报告查询系统</div>
        </el-header>
        <el-container>
          <el-main>
            <img src="../assets/sfy/bg.jpg"/>
          </el-main>
          <el-aside width="350px" class="login" style="overflow: hidden">
            <login v-on:loginSuccess="loginSuccess"></login>
          </el-aside>
        </el-container>
      </div>
    </el-main>
    <el-footer id="footer" height="120px">

    </el-footer>
  </el-container>
</template>

<script>
  import Login from '@/components/Login.vue'
  import {keyCodes} from '../commons'

  export default {
    data() {
      return {
        containerHeight: 0
      }
    },
    props: {},
    computed: {
      containerStyle: function () {
        return {
          height: this.containerHeight + 'px',
          maxHeight: this.containerHeight + 'px',
        }
      }
    },
    components: {
      Login
    },
    methods: {
      /**
       * 登陆成功后回调
       */
      loginSuccess(){
        const _this = this;
        _this.$store.dispatch('setLoginBy',keyCodes.LOGIN_BY_SFY)
      }
    },
    watch: {},
    mounted(){
      $('#years').text(new Date().getFullYear());
      const _this = this;
      _this.containerHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      window.onresize = function windowResize() {
        _this.containerHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      }
    }
  }
</script>

<style scoped lang="scss">
  .loginHeader{
    padding: 0px 30px 0px 60px;
    background-color: #f2a5c5;
    img {
      width: 120px;
      height: 120px
    }
  }
  .mainContainer {
    width: 1150px;
    height: 531px;
    margin: 30px auto;
  }

  .mainContainer .tile {
    font-size: 24px;
    font-weight: bold
  }

  .mainContainer main {
    padding: 0px;
    overflow: hidden;
  }

  .mainContainer img {
    width: 800px;
    height: 480px;
  }

  .login {
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    margin: 0px auto;
  }

  #footer {
    line-height: 40px;
    color: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: #f2a5c5;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
  }
  .title {
    float: left;
    line-height: 40px;
    padding-left: 20px;

    div {
      height: 40px;
      text-align: left;
    }

    .title-main {
      font-size: 28px;
      font-weight: bold;
    }

    .title-sub {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
    }
  }
  .title2 {
    font-size: 28px;
    font-weight: bold;
    color: #f2a5c5;
    line-height: 40px;
    padding-left: 20px;
    margin-top: 20px;
    text-shadow: 5px 5px 5px #909399;
    div {
      height: 40px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/LoginShengFuYou.vue